import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {AllInterCompanyFields} from '@enum/client/inter-company-field';
import {AllUserAreaFilters} from '@enum/user-area/user-area-filter';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';
import {UserPermissionManager} from './user-permission';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {AllUserAreaColumns} from '@enum/user-area/user-area-column';
import {AllCrmSections} from '@enum/crm-section';

class AdminPermissionClass implements UserPermission {
  readonly userRole = UserRole.ADMIN;
  readonly labelRole = 'Customer Service';
  readonly isAuthenticated = true;

  readonly canRequestEto = true;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = true;

  readonly canModifyAllConfigurations = true;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = true;
  readonly canSeeHisAccountInRightDrawer = false;
  readonly canSeeHisAccountPreferences = true;
  readonly canHaveManyEditableProforma = true;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = true;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = true;
  readonly crmSectionsVisible = AllCrmSections;
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly editableInterCompanyDependentFields = AllInterCompanyFields;
  readonly visibleInterCompanyDependentFields = AllInterCompanyFields;

  readonly visibleUserAreaFilters = AllUserAreaFilters;
  readonly visibleUserAreaColumns = AllUserAreaColumns;

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = true;
  readonly canSeeAssignedUserStats = true;

  readonly canSelfAssignClaims = true;
  readonly canEditClaimAnswer = true;
  readonly canOpenNewClaims = true;
  readonly canHandleAdvancedClaimInfo = true;

  readonly canGiveExpirationFeedback = true;
  readonly canDownloadPackingList = true;
  readonly canSeeConfigurationList = true;
  readonly canSeeCustomerConfigurationTab = true;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = true;

  readonly composerAllowed = true;
}

const AdminPermission = new AdminPermissionClass();

UserPermissionManager.instance.assignPermissionWithCheckingFn(
  AdminPermission,
  ({role}) => role === AdminPermission.userRole || role === UserRole.CUSTOMER_SERVICE
);
